package floris.graphics.backoffice.pages.admin.contributors

import floris.graphics.models.domain.models.Contributor
import floris.graphics.repo.ContributorRepo
import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.Dispatchers
import kotlinx.coroutines.SupervisorJob
import kotlinx.coroutines.channels.Channel
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.asStateFlow
import kotlinx.coroutines.flow.receiveAsFlow
import kotlinx.coroutines.flow.update
import kotlinx.coroutines.launch

class ContributorsViewModel(
    private val contributorRepo: ContributorRepo = ContributorRepo,
    private val coroutineScope: CoroutineScope = CoroutineScope(SupervisorJob() + Dispatchers.Default)
) {
    private val _state = MutableStateFlow(ContributorsState())
    val state = _state.asStateFlow()

    private val _eventFlow = Channel<ContributorsUiEvent>()
    val eventFlow = _eventFlow.receiveAsFlow()

    fun onEvent(event: ContributorsEvent) = coroutineScope.launch {
        when (event) {
            ContributorsEvent.LoadContributors -> {
                _state.update { it.copy(isLoading = true) }
                val items = contributorRepo.getContributors()
                _state.update { it.copy(contributors = items, isLoading = false) }
            }

            is ContributorsEvent.Navigate -> _eventFlow.send(ContributorsUiEvent.Navigate(event.route))
        }
    }

    init {
        onEvent(ContributorsEvent.LoadContributors)
    }
}

data class ContributorsState(
    val contributors: List<Contributor> = emptyList(),
    val isLoading: Boolean = false,
    val errorText: String = ""
)

sealed class ContributorsEvent {
    data object LoadContributors : ContributorsEvent()
    data class Navigate(val route: String) : ContributorsEvent()
}

sealed class ContributorsUiEvent {
    data class Navigate(val route: String) : ContributorsUiEvent()
}
